const NAVBAR_HEIGHT = 85;

export default NAVBAR_HEIGHT;
